import Cookies from 'js-cookie';
import { selectLaunchTarget } from 'shared/helpers/pwaLaunch';

const target = selectLaunchTarget({
  hasSession: Boolean(Cookies.get('cw_d_session_info')),
  search: window.location.search,
  hash: window.location.hash,
});

if (target) {
  window.location.replace(target);
} else {
  // The dashboard retains authoritative token validation and account routing.
  import('./dashboard');
}
